<template>
  <div class="contain">
    <el-container class="is-vertical">
      <AppBar />

      <el-container class="custom-container">
        <SideNav />

        <template v-if="$route.path !== '/'">
          <MenuFrame>
            <slot></slot>
          </MenuFrame>
        </template>
        <template v-else>
          <slot></slot>
        </template>
      </el-container>
    </el-container>

    <DingDong />
    <NoticeDialog />
    <AgreementDialog />
  </div>
</template>

<script>
import DingDong from './common/DingDong.vue'
import AgreementDialog from './common/AgreementDialog.vue'
import AppBar from './common/AppBar.vue'
import SideNav from './common/SideNav.vue'
import NoticeDialog from './common/NoticeDialog.vue'
import MenuFrame from './common/MenuFrame.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppBar,
    SideNav,
    MenuFrame,
    DingDong,
    AgreementDialog,
    NoticeDialog,
  },
}
</script>

<style scoped>
.contain {
  width: 100%;

  height: 100%;
  min-height: 100vh;

  background-color: var(--color-bg-page);
  color: var(--color-text-regular);
  overflow: auto;
}
.custom-container {
  height: calc(100vh - 63px);
}
</style>
